import { API_URL } from '@/lib/constants';

interface MediaItem {
  id: string;
  url: string;
  media_type: string;
  width?: number | null;
  height?: number | null;
  alt_text?: string | null;
}

interface MediaGridProps {
  media: MediaItem[];
}

export function MediaGrid({ media }: MediaGridProps) {
  if (!media || media.length === 0) return null;

  const count = media.length;

  // Build full URL for media
  const getUrl = (item: MediaItem) => {
    if (item.url.startsWith('http')) return item.url;
    // Relative URL - prepend API base
    return `${API_URL}${item.url.startsWith('/api/v1') ? item.url.slice(7) : item.url}`;
  };

  if (count === 1) {
    return (
      <div className="mt-3 rounded-xl overflow-hidden border border-border/50">
        <img
          src={getUrl(media[0])}
          alt={media[0].alt_text || 'Post image'}
          className="w-full max-h-[400px] object-cover"
          loading="lazy"
        />
      </div>
    );
  }

  if (count === 2) {
    return (
      <div className="mt-3 grid grid-cols-2 gap-0.5 rounded-xl overflow-hidden border border-border/50">
        {media.map((item) => (
          <img
            key={item.id}
            src={getUrl(item)}
            alt={item.alt_text || 'Post image'}
            className="w-full h-[200px] object-cover"
            loading="lazy"
          />
        ))}
      </div>
    );
  }

  if (count === 3) {
    return (
      <div className="mt-3 grid grid-cols-2 gap-0.5 rounded-xl overflow-hidden border border-border/50">
        <img
          src={getUrl(media[0])}
          alt={media[0].alt_text || 'Post image'}
          className="w-full h-[250px] object-cover row-span-2"
          loading="lazy"
        />
        <img
          src={getUrl(media[1])}
          alt={media[1].alt_text || 'Post image'}
          className="w-full h-[124px] object-cover"
          loading="lazy"
        />
        <img
          src={getUrl(media[2])}
          alt={media[2].alt_text || 'Post image'}
          className="w-full h-[124px] object-cover"
          loading="lazy"
        />
      </div>
    );
  }

  // 4 images: 2x2 grid
  return (
    <div className="mt-3 grid grid-cols-2 gap-0.5 rounded-xl overflow-hidden border border-border/50">
      {media.slice(0, 4).map((item) => (
        <img
          key={item.id}
          src={getUrl(item)}
          alt={item.alt_text || 'Post image'}
          className="w-full h-[150px] object-cover"
          loading="lazy"
        />
      ))}
    </div>
  );
}
